export const MAGIC_LINK_EXPIRES_IN_MINUTES = 43800; // 30 days
